import { RunAiAgentSseEvent } from '../types/runAiAgent.types';

/**
 * Builds a chunk appender for one agent run, so each run buffers and parses
 * its own SSE frames independently of any other concurrent run.
 */
export const createAiAgentMessageAppender = () => {
  let buffer = '';

  return (draft: { text: string }, chunk: string): void => {
    buffer += chunk;
    const events = buffer.split('\n\n');
    buffer = events.pop() ?? '';
    for (const raw of events) {
      const dataLine = raw.split('\n').find((l) => l.startsWith('data: '));
      if (!dataLine) continue;
      try {
        const event = JSON.parse(dataLine.slice(6)) as RunAiAgentSseEvent;
        if (event._type === 'message' && event.role === 'assistant') {
          const textContent = event.content.find((c) => c._type === 'text');
          if (textContent) {
            draft.text = draft.text
              ? draft.text + '\n' + textContent.text
              : textContent.text;
          }
        }
      } catch {
        // malformed SSE line, skip
      }
    }
  };
};
